/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Import global packages
------------------------------------------------------------------*/

import * as Meteora from 'meteora';
import Classy from '@meteora-digital/classy';
import TweenController from '@meteora-digital/tween';
import MagicScrollsController from 'magic-scrolls';
import { tns } from "tiny-slider/src/tiny-slider";

/*------------------------------------------------------------------
Assign global packages to the window object
------------------------------------------------------------------*/

window.Classy = Classy;
window.Meteora = Meteora;
window.TweenController = TweenController;
window.MagicScrollsController = MagicScrollsController;
window.tns = tns;

/*------------------------------------------------------------------
Add scripts to the ScriptLoader object below
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './components/global': true,
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './components/equalizer': document.querySelector('[data-equalize-watch]'),
    './elements/mega-menu.js': document.querySelector('.js-mega-menu'),
    './elements/videos': document.querySelector('[data-video]'),
    './elements/video-modals': document.querySelector('[data-video-modal]'),
    './elements/banner': document.querySelector('.js-banner'),
    './blocks/default/accordion': document.querySelector('.js-default-accordion'),
    './blocks/default/tabs': document.querySelector('.js-default-tabs'),
    './blocks/default/image-reveal': document.querySelector('.js-default-image-reveal'),
    './blocks/default/sample': document.querySelector('.js-default-sample-block'),
    './pages/contact': document.querySelector('.js-contact form')
  });
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader() {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // An array of the import object keys
  var scripts = Object.keys(imports);
  // For debugging purposes only
  var components = [];
  // The index we are up to with loading scripts
  var index = -1;
  var load = function load() {
    // Make sure we have a script to import
    if (index >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event 
      setTimeout(function () {
        return window.dispatchEvent(new Event('scripts-loaded'));
      }, 500);
      return;
    }
    ;

    // Increment the index
    index += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[index]]) {
      load();
      return;
    }
    ;

    // Otherwise continue on to load the script
    import("".concat(scripts[index])).then(function () {
      return components.push(scripts[index]);
    })["catch"](function (error) {
      return console.warn(error);
    })["finally"](function () {
      return load();
    });
  };
  load();
  return components;
}
window.addEventListener('scripts-loaded', function () {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
  window.ScrollLocker.unlock();
  window.scrollTo(0, 0);
});